import Tittle from "./titel";
import SelectFrame from "./selectFrame";
import { useState, useContext, useRef, useEffect } from "react";
import { getPaintingPrice } from "../../api-route/painting";
import { CartContext } from "../../providers/CartContextProvider";
import { IsInCart, quantityItem } from "../../helper/functions";
import addComma from "../../Functions/numberFormat";
import { Link } from "react-router-dom";
import Pa from "./SelectPasparto";
import arrowRight from "../../assets/arrows-left-right.webp"
import arrowDown from "../../assets/arrows-up-down.webp"
import "./style.css"



const B = ({ title: t, value: v, handler: h, loading: loading, source: arrow, isMobile: isMobile }) => (<div className={"flex flex-col gap-1 " + (isMobile ? "w-[45%]" : "w-full")}>
    <div className="flex flex-row justify-end">
        <img className={"mr-4 " + (arrow.includes("right") ? "w-5 h-3 mt-1" : "h-4 w-3")} src={arrow} alt="" />
        <span className="text-secondary text-sm mr-1">{t} (cm)</span>
    </div>
    <div className="centerOfParent rounded-md overflow-hidden p-1 border border-secondary flex justify-center align-center" id="heightWidthInput">
        {loading ? <p className={"mb-1 text-red-800 text-sm text-center " + (isMobile ? "truncate" : "")} style={{ direction: 'rtl' }}>لطفا صبر کنید</p> : <input onClick={e => e.target.value = ''} type="number" className="w-full border-none text-center h-6"
            value={v} onChange={h} />}
    </div>
</div>);

export default function A({ Painting: p, setMainImage: m, mainImage: i, setWidth: w, passpartout: u, setPasspartout: o, setHeight: x, width: d, height: y }) {
    const { id: n } = p;
    const a = p.ratio_paintings[0]?.width_ratio_value / p.ratio_paintings[0]?.height_ratio_value;
    const { state: s, dispatch: c } = useContext(CartContext)
    const f = useRef(null);
    const j = useRef(null);
    const [k, F] = useState({ id: null })
    const [P, M] = useState({})
    const [z, D] = useState(false)
    const [maxX, setMaxX] = useState(0)
    const [maxY, setMaxY] = useState(0)
    const [loadingWidth, setLoadingWidth] = useState(false);
    const [loadingHeight, setLoadingHeight] = useState(false);
    const V = { ...p, size: { width: d, height: y }, price: P, frame: k, mainImage: i, passpartout: u }
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [firstTime, setFirstTime] = useState(true);
    useEffect(() => {
        const initialWidth = 100;
        const initialHeight = 100;
        const fetchData = async (width, height) => {
            const g = await getPaintingPrice(n, k.id, width, height);
            M(g?.price ? { price: g.price, frame_price: g.frame_price } : {});
            x(g?.height || height);
            w(g?.width || width);
            D(e => g.error ? true : false);

            setMaxX(g?.width);
            setMaxY(g?.height);

        };

        const handleInitialRequest = async () => {
            setLoadingHeight(true);
            setLoadingWidth(true);

            await fetchData(initialWidth, Math.round(initialWidth / a));

            if (Math.round(initialWidth / a) < initialHeight) {
                await fetchData(Math.round(initialHeight * a), initialHeight);
            }

            setLoadingHeight(false);
            setLoadingWidth(false);
        };

        handleInitialRequest();
        setFirstTime(false);

    }, [])
    // E(() => {
    //     const initialWidth = 100;
    //     const initialHeight = 100;
    //     const fetchData = async (width, height) => {
    //         const g = await G(n, k.id, width, height);
    //         M(g?.price ? { price: g.price, frame_price: g.frame_price } : {});
    //         x(g?.height || height);
    //         w(g?.width || width);
    //         D(e => g.error ? true : false);


    //     };

    //     const handleInitialRequest = async () => {
    //         setLoadingHeight(true);
    //         setLoadingWidth(true);

    //         await fetchData(initialWidth, Math.round(initialWidth / a));

    //         if (Math.round(initialWidth / a) < initialHeight) {
    //             await fetchData(Math.round(initialHeight * a), initialHeight);
    //         }

    //         setLoadingHeight(false);
    //         setLoadingWidth(false);

    //     };

    //     handleInitialRequest();
    // }, [k.id, n, u]);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        // Set initial screen width
        handleResize();

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Cleanup function to remove the listener when the component unmounts
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);



    useEffect(() => {
        return () => {
            clearTimeout(f.current);
            clearTimeout(j.current);
        };
    }, []);

    useEffect(() => {
        const H = async () => {
            const g = await getPaintingPrice(n, k.id, d, y, u)
            M(g?.price ? { price: g.price, frame_price: g.frame_price } : {})
            x(g?.height || y)
            D(e => g.error ? true : false)

        }
        if (!firstTime) {
            H()
        }
    }, [k.id, n, u])

    const O = (e) => {
        setLoadingHeight(true);
        const b = parseInt(e.target.value);
        clearTimeout(f.current);
        w(b);
        f.current = setTimeout(async () => {
            const N = Math.round(b / a);
            x(N);
            try {
                const g = await getPaintingPrice(n, k.id, b, N)
                M(g?.price ? { price: g.price, frame_price: g.frame_price } : {})
                D(q => g.error ? true : false)

            }
            finally {
                setLoadingHeight(false);
            }

        }, 1500);
    };

    const U2 = (e) => {
        setLoadingWidth(true);
        const q = parseInt(e.target.value);
        x(q);
        clearTimeout(j.current);
        j.current = setTimeout(async () => {
            const S = Math.round(q * a);
            w(S);
            try {
                const g = await getPaintingPrice(n, k.id, S, q)
                M(g?.price ? { price: g.price, frame_price: g.frame_price } : {})
                D(h => g.error ? true : false)
            }
            finally {
                setLoadingWidth(false);
            }

        }, 1500);
    }
    return (
        screenWidth > 767.5 ? <aside className="bg-white border col-span-4 xl:col-span-3 h-fit px-4 py-8 rounded-md text-right w-fit">
            <Tittle title="لطفا سایز دلخواه را وارد کنید" className='mb-4 mt-4' />
            <div className="mb-3 text-red-800 text-sm">
            </div>

            <div className="flex justify-between gap-4 mb-4">
                <B title="عرض" value={d} handler={O} loading={loadingWidth} source={arrowRight} isMobile={false} />
                <B title="ارتفاع" value={y} handler={U2} loading={loadingHeight} source={arrowDown} isMobile={false} />
            </div>
            <h2 className="mb-2">:سایزهای پیشنهادی</h2>

            {
                maxX == 0 ? <p>...لطفا صبر کنید</p> :
                    <div className="flex flex-row flex-wrap justify-between gap-3 mb-4">
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.9);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.9)} x {Math.round(maxY * 0.9)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.8);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.8)} x {Math.round(maxY * 0.8)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.6);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.6)} x {Math.round(maxY * 0.6)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.4);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.4)} x {Math.round(maxY * 0.4)}</button>
                    </div>
            }
            <Tittle title="لطفا قاب مدنظر را انتخاب کنید" />
            <SelectFrame setFrame={F} setMainImage={m} mainImage={i} id={p.id} width={d} isMobile={false} />
            {k.id === 79 ? null : <Tittle title="پاسپارتو" />}
            {k.id === 79 ? null : <Pa setMainImage={m} passpartout={u} id={p.id} frame={k.id} width={d} setPasspartout={o} isMobile={false} />}
            <Tittle title="قیمت نهایی" />
            <p className="centerOfParent mt-4 flex-row-reverse text-center text-[25px]">
                <div className="">{addComma(P.frame_price ? (P.price) : 0)}</div>
                <span className="mr-3">تومان</span>
            </p>
            <p className="text-center text-[16px] mt-5 mb-3">
                <span className="font-bold">مدت زمان تحویل: </span>
                <span>۵ الی ۷ روز کاری</span>
            </p>
            <div className='centerOfParent flex-col gap-4'>
                {!!P && (IsInCart(s, V) ?
                    <div className='flex items-center py-1 px-2 my-1 mx-2 border border-primary rounded justify-between text-primary'>
                        <button className='centerOfParent bg-none border-0 py-2 px-1'>
                            {quantityItem(s, V) < 2 ?
                                <svg onClick={() => c({ type: "REMOVE_ITEM", payload: V })} className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                                :
                                <svg onClick={() => c({ type: "DECREASE", payload: V })} className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            }
                        </button>
                        <span className='centerOfParent text-xl my-1 mx-3'>{quantityItem(s, V)}</span>
                        <button className="centerOfParent bg-none border-0 py-2 px-1"
                            onClick={() => c({ type: 'INCREASE', payload: V })}>
                            <svg className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                        </button>
                    </div> :
                    <button onClick={() => c({ type: "ADD_ITEM", payload: V })} disabled={z} className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                        <span>افزودن به سبد خرید</span>
                    </button>)}
                {IsInCart(c, V) && <Link to='/checkout/cart' className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                    <span>رفتن به سبد خرید</span>
                </Link>}
            </div>
        </aside>
            : <div>
                <Tittle title="لطفا سایز دلخواه را وارد کنید" className='mb-4 mt-4' />
                <div className="flex flex-row flex-wrap justify-between gap-3 mt-2 mb-4">
                    <B title="عرض" value={d} handler={O} loading={loadingWidth} source={arrowRight} isMobile={true} />
                    <B title="ارتفاع" value={y} handler={U2} loading={loadingHeight} source={arrowDown} isMobile={true} />
                </div>
                {
                    maxX == 0 ? <p>...لطفا صبر کنید</p> :
                    <div className="flex flex-row flex-wrap justify-between gap-3 mb-4">
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.9);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.9)} x {Math.round(maxY * 0.9)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.8);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.8)} x {Math.round(maxY * 0.8)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.6);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.6)} x {Math.round(maxY * 0.6)}</button>
                        <button className="bg-primary border-1 rounded-lg text-white w-20 h-9" onClick={() => {
                            const newWidth = Math.round(maxX * 0.4);
                            O({ target: { value: newWidth } });
                        }}>{Math.round(maxX * 0.4)} x {Math.round(maxY * 0.4)}</button>
                    </div>
                }
                <Tittle title="لطفا قاب مدنظر را انتخاب کنید" />
                <SelectFrame setFrame={F} setMainImage={m} mainImage={i} id={p.id} width={d} isMobile={true} />
                <div className="flex flex-row-reverse justify-between">
                    {k.id === 79 ? null : <Pa setMainImage={m} passpartout={u} id={p.id} frame={k.id} width={d} setPasspartout={o} isMobile={true} />}
                    <p className="centerOfParent mt-4 flex-row-reverse text-center text-[25px]">
                        {console.log('P: ', P)}
                        <div className="">{addComma(P.frame_price ? (P.price) : 0)}</div>
                        <span className="mr-3">تومان</span>
                    </p>
                </div>
                <p className="text-center text-[16px] mt-5 mb-3">
                    <span className="font-bold">مدت زمان تحویل: </span>
                    <span>۵ الی ۷ روز کاری</span>
                </p>
                <div className='centerOfParent flex-col gap-4'>
                    {!!P && (IsInCart(s, V) ?
                        <div className='flex items-center py-1 px-2 my-1 mx-2 border border-primary rounded justify-between text-primary'>
                            <button className='centerOfParent bg-none border-0 py-2 px-1'>
                                {quantityItem(s, V) < 2 ?
                                    <svg onClick={() => c({ type: "REMOVE_ITEM", payload: V })} className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                    :
                                    <svg onClick={() => c({ type: "DECREASE", payload: V })} className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                }
                            </button>
                            <span className='centerOfParent text-xl my-1 mx-3'>{quantityItem(s, V)}</span>
                            <button className="centerOfParent bg-none border-0 py-2 px-1"
                                onClick={() => c({ type: 'INCREASE', payload: V })}>
                                <svg className="cursor-pointer" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </button>
                        </div> :
                        <button onClick={() => c({ type: "ADD_ITEM", payload: V })} disabled={z} className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                            <span>افزودن به سبد خرید</span>
                        </button>)}
                    {IsInCart(c, V) && <Link to='/checkout/cart' className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                        <span>رفتن به سبد خرید</span>
                    </Link>}
                </div>

            </div>
    );
}
